export const DashedLine = () => (
    <div className="w-full">
        <svg viewBox="0 0 100 1" preserveAspectRatio="none" className="w-full h-[1px]">
            <line x1="0" y1="0.5" x2="100" y2="0.5" stroke="#7CC58F" strokeWidth="1" strokeDasharray="0.5 0.4" />
        </svg>
    </div>
)